var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 7.16797H4.5835C3.40933 7.16797 2.7085 6.6073 2.7085 5.66797V3.66797C2.7085 2.72864 3.40933 2.16797 4.5835 2.16797H15.4168C16.591 2.16797 17.2918 2.72864 17.2918 3.66797V5.66797C17.2918 6.6073 16.591 7.16797 15.4168 7.16797ZM4.5835 3.16797C4.09266 3.16797 3.9585 3.2753 3.9585 3.66797V5.66797C3.9585 6.06064 4.09266 6.16797 4.5835 6.16797H15.4168C15.9077 6.16797 16.0418 6.06064 16.0418 5.66797V3.66797C16.0418 3.2753 15.9077 3.16797 15.4168 3.16797H4.5835ZM15.4168 13.8346H4.5835C3.40933 13.8346 2.7085 13.274 2.7085 12.3346V10.3346C2.7085 9.3953 3.40933 8.83463 4.5835 8.83463H15.4168C16.591 8.83463 17.2918 9.3953 17.2918 10.3346V12.3346C17.2918 13.274 16.591 13.8346 15.4168 13.8346ZM4.5835 9.83463C4.09266 9.83463 3.9585 9.94197 3.9585 10.3346V12.3346C3.9585 12.7273 4.09266 12.8346 4.5835 12.8346H15.4168C15.9077 12.8346 16.0418 12.7273 16.0418 12.3346V10.3346C16.0418 9.94197 15.9077 9.83463 15.4168 9.83463H4.5835Z",
    fill: "#F4F5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/menu_button.5979e99c00c51c47e1a99c71064057c8.svg";
export { ForwardRef as ReactComponent };